import { component, OnInit, prop } from '@gbds/core/src/ts/core'
import { initImgZoom } from './img-zoom'

/**
 * @noInheritDoc
 */
@component('gb-wrapper')
export class Wrapper extends HTMLElement implements OnInit {
	buttonEl: HTMLButtonElement

	/**
	 * Button link type.
	 */
	@prop()
	public dataLinkType: string

	constructor() {
		super()
	}

	onInit(): void {
		if (this.dataLinkType === 'targetZone') {
			this.buttonEl = this.querySelector('button') as HTMLButtonElement

			if (this.buttonEl) {
				const isAuthenticated = window.gbpe?.auth?.currentAuthState === 1

				const targetZoneId = isAuthenticated
					? this.buttonEl.getAttribute('data-auth-target-zone-id') ||
					  this.buttonEl.getAttribute('data-target-zone-id')
					: this.buttonEl.getAttribute('data-target-zone-id')

				const targetZoneSectionId = isAuthenticated
					? this.buttonEl.getAttribute('data-auth-target-zone-section-id') ||
					  this.buttonEl.getAttribute('data-target-zone-section-id')
					: this.buttonEl.getAttribute('data-target-zone-section-id')

				this.buttonEl.onclick = e => this.changeTargetZone(e, targetZoneId, targetZoneSectionId)
			} else {
				console.log('Button element not found within component')
			}
		}

		// Initialize img-zoom if applicable
		if (this.dataLinkType === 'img-zoom') {
			initImgZoom(this)
		}
	}

	/**
	 * Creates an event to change the target zone.
	 */
	changeTargetZone(e: Event, targetZoneId: string | null, targetZoneSectionId: string | null): void {
		e.preventDefault()
		e.stopPropagation()

		const eventOpts = {
			bubbles: true,
			cancelable: false,
			detail: {
				zoneID: targetZoneId,
				targetZoneID: targetZoneSectionId,
				sourceRoot: this.getRootNode(),
			},
		}

		// Dispatch custom event for target zone change
		const evt = new CustomEvent('targetZoneChange', eventOpts)
		window.dispatchEvent(evt)
	}
}
